import React from "react";
import Img from "react-image";
import _ from "lodash";
import { connect } from "react-redux";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import moment from "moment";
import Classnames from "classnames";
import { withTranslation } from 'react-i18next';
import { TimePickerCustom } from "../../../../../../../src/components"

import {
  postSanteSimple,
  updateSanteEvent,
  deleteSanteEvent,
} from "../les-tabs-ducks/Sante.ducks";

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}

class Sante extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objetSante: "",
      etatSante: "",
      readySubmit: false,
      show: false,
      check: false,
      opacity: { opacity: 0.25 },
      initialized: false,
      isOpen: true,
      timeSante: moment(),
      remarque: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handlecheck = this.handlecheck.bind(this);
    this.myChangeHandler = this.myChangeHandler.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (
      !this.state.initialized &&
      (this.props.isUpdate || this.props.onlyView) &&
      !_.isEmpty(this.props.santeData)
    ) {
      let santeData = this.props.santeData;
      let kidItem = this.props.kidItem;
      if (santeData.typeIncident === "AUTRE") {
        this.setState({
          timeSante: moment(santeData.dateTime),
          etatSante: santeData.etatSante,
          remarque: santeData.remarque,
          objetSante: "AUTRE",
          initialized: true,
          show: true,
        });
      } else {
        this.setState({
          timeSante: moment(santeData.dateTime),
          etatSante: santeData.etatSante,
          remarque: santeData.remarque,
          objetSante: santeData.typeIncident,
          initialized: true,
          show: false,
        });
      }
    }
  }
  toggle() {
    this.props.toggle();
    this.setState({ readySubmit: false, objetSante: "", etatSante: "" });
  }
  myChangeHandler = (event) => {
    this.setState({ remarque: event.target.value }, () => {
      let opac =
        notEmpty(this.state.etatSante) && notEmpty(this.state.remarque)
          ? { opacity: 1 }
          : { opacity: 0.25 };
      this.setState({ opacity: opac });
      if (
        notEmpty(this.state.etatSante) &&
        notEmpty(this.state.objetSante) &&
        notEmpty(this.state.remarque) &&
        !this.props.readySubmit
      ) {
        this.props.handleReadySubmit();
      } else if (_.isEmpty(this.state.remarque) && this.props.readySubmit) {
        this.props.handleReadySubmit();
      }
    });
  };

  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.name;
      this.setState(
        { [name]: event.target.id, opacity: { opacity: 0.25 } },
        () => {
          let readySubmit = this.props.readySubmit;
          if (
            this.state.objetSante !== "AUTRE" &&
            notEmpty(this.state.objetSante) &&
            notEmpty(this.state.etatSante)
          ) {
            this.props.handleReadySubmit();
            this.setState({ opacity: { opacity: 1 } });
          } else if (
            this.state.objetSante === "AUTRE" &&
            notEmpty(this.state.etatSante) &&
            notEmpty(this.state.remarque)
          ) {
            this.props.handleReadySubmit();
            this.setState({ opacity: { opacity: 1 } });
          } else {
            this.setState({ opacity: { opacity: 0.25 } });
          }
        }
      );

      if (event.target.id === "AUTRE") {
        this.setState({
          show: true,
        });
      } else if (event.target.name !== "etatSante") {
        this.setState({
          show: false,
          remarque: "",
        });
        this.props.handleReadySubmit();
      }
    }
  };

  handleChangeDate = (date) => {
    if (!this.props.onlyView) {
      this.setState({ timeSante: date }, () => {
        if (
          notEmpty(this.state.timeSante)
        ) {
          this.setState({ opacity: { opacity: 1 } });
        } else {
          this.setState({ opacity: { opacity: 0.25, pointerEvents: "none" } });
        }
      });
    }
  };

  handleSubmit(event) {
    event.preventDefault();

    if (
      this.props.isUpdate &&
      notEmpty(this.props.kidItem) &&
      notEmpty(this.state.etatSante) &&
      notEmpty(this.state.objetSante)
    ) {
      let data = {
        dateTime: moment(this.state.timeSante).format(),
        etatSante: this.state.etatSante,
        remarque: this.state.remarque,
        typeIncident: this.state.objetSante,
      };
      this.props.updateSanteEvent(
        localStorage.getItem("token"),
        this.props.idEvent,
        data,
        this.props.kidItem.id
      );
    } else {
      let data = {
        dateTime: moment(this.state.timeSante).format(),
        etatSante: this.state.etatSante,
        remarque: this.state.remarque,
        typeIncident: this.state.objetSante,
      };
      let readySubmit = this.props.readySubmit;
      let tabSubmit;
      notEmpty(this.state.objetSante) && notEmpty(this.state.etatSante)
        ? (tabSubmit = true)
        : (tabSubmit = false);
      if (tabSubmit) {
        this.props.postSanteSimple(
          localStorage.getItem("token"),
          this.props.kidItem.id,
          data
        );
        this.props.handleSubmit();
      }
    }
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.deleteSanteEvent(
      localStorage.getItem("token"),
      this.props.idEvent,
      this.props.kidItem.id
    );
  }

  handlecheck() {
    if (notEmpty(this.state.objetSante)) {
      return { pointerEvents: "auto" };
    }
    return { pointerEvents: "none" };
  }
  render() {
    const { t } = this.props;
    return (
      <div
        className="tab-pane  show active"
        id="sante-pane"
        role="tabpanel"
        aria-labelledby="sante-tab"
      >
        <div className="content">
        <h2 className="mb-2">{t('modal_enfant.sante_tab.at_what_time')}</h2>
            <TimePickerCustom 
              isOpen={this.state.isOpen} 
              time={this.state.timeSante} 
              handleChangeDate={this.handleChangeDate} 
              onlyView={this.props.onlyView}/>

          <h2 style={{ marginTop: "15px" }}>{t('modal_enfant.sante_tab.select_object')}</h2>
          <div className="row mx-n2 mb-4 d-flex align-items-center justify-content-center choices-objets objet-sante">
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="FIEVRE"
                value={this.state.typeActivite}
                name="objetSante"
              />
              <label
                htmlFor="FIEVRE"
                className={Classnames("fievre", {
                  active: this.state.objetSante === "FIEVRE",
                })}
              >
                <span>{t('modal_enfant.sante_tab.fievre')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="VOMI"
                value={this.state.objetSante}
                name="objetSante"
              />
              <label
                htmlFor="VOMI"
                className={Classnames("vomi", {
                  active: this.state.objetSante === "VOMI",
                })}
              >
                <span>{t('modal_enfant.sante_tab.vomi')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="TOUX"
                value={this.state.objetSante}
                name="objetSante"
              />
              <label
                htmlFor="TOUX"
                className={Classnames("toux", {
                  active: this.state.objetSante === "TOUX",
                })}
              >
                <span>{t('modal_enfant.sante_tab.toux')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="BLESSURE"
                value={this.state.objetSante}
                name="objetSante"
              />
              <label
                htmlFor="BLESSURE"
                className={Classnames("blessure", {
                  active: this.state.objetSante === "BLESSURE",
                })}
              >
                <span>{t('modal_enfant.sante_tab.blessure')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="BOUTONS"
                value={this.state.objetSante}
                name="objetSante"
              />
              <label
                htmlFor="BOUTONS"
                className={Classnames("boutons", {
                  active: this.state.objetSante === "BOUTONS",
                })}
              >
                <span>{t('modal_enfant.sante_tab.boutons')}</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                disabled={this.props.onlyView}
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="AUTRE"
                value={this.state.objetSante}
                name="objetSante"
              />
              <label
                htmlFor="AUTRE"
                className={Classnames("autres", {
                  active: this.state.objetSante === "AUTRE",
                })}
              >
                <span>{t('modal_enfant.sante_tab.autres')}</span>
              </label>
            </div>
          </div>
          {this.state.show ? (
            <div className="container-message autre-etat-sante mt-3">
              <textarea
                className="box-shadow"
                value={this.state.remarque}
                onChange={this.myChangeHandler}
              ></textarea>
            </div>
          ) : (
            ""
          )}
          <div className="etat-sante">
            <h2>{t('modal_enfant.sante_tab.child_state')}</h2>
            <div className="row mx-n2 justify-content-center">
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="RIEN_DE_GRAVE"
                  value={this.state.etatSante}
                  name="etatSante"
                />
                <label
                  htmlFor="RIEN_DE_GRAVE"
                  className={Classnames(
                    "btn-white btn-border",
                    { active: this.state.etatSante === "RIEN_DE_GRAVE" },
                    { disablePointer: _.isEmpty(this.state.etatSante) },
                    { enablePointer: notEmpty(this.state.etatSante) }
                  )}
                >
                  {t('modal_enfant.sante_tab.nothing_serious')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="A_SURVEILLER"
                  value={this.state.etatSante}
                  name="etatSante"
                />
                <label
                  htmlFor="A_SURVEILLER"
                  className={Classnames(
                    "btn-white btn-border",
                    { active: this.state.etatSante === "A_SURVEILLER" },
                    { disablePointer: _.isEmpty(this.state.etatSante) },
                    { enablePointer: notEmpty(this.state.etatSante) }
                  )}
                >
                  {t('modal_enfant.sante_tab.to_monitor')}
                </label>
              </div>
              <div className="col-md-4 px-2">
                <input
                  disabled={this.props.onlyView}
                  onChange={this.handleChange}
                  type="radio"
                  className="d-none"
                  id="INQUIETANT"
                  value={this.state.etatSante}
                  name="etatSante"
                />
                <label
                  htmlFor="INQUIETANT"
                  className={Classnames(
                    "btn-white btn-border",
                    { active: this.state.etatSante === "INQUIETANT" },
                    { disablePointer: _.isEmpty(this.state.etatSante) },
                    { enablePointer: notEmpty(this.state.etatSante) }
                  )}
                >
                  {t('modal_enfant.sante_tab.worrying')}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {this.props.onlyView ? (
            ""
          ) : (
            <button
              type="submit"
              className="btn-gradient btn-valid"
              onClick={(event) =>
                this.handleSubmit(event, this.state.presentIds)
              }
              style={this.state.opacity}
            >
              <IconCheckWhite /> {t('common.send')}
            </button>
          )}
          {this.props.isUpdate ? (
            <button onClick={this.handleEventDelete} className="btn-supprimer">
              {t('common.delete')}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default connect(null, {
postSanteSimple,
  updateSanteEvent,
  deleteSanteEvent,
})(withTranslation()(Sante));
